import React from 'react'
import styles from './SelectableList.scss'
import cx from 'classnames'

export const SelectableList = ({children}) => (
  <div className={styles.SelectableList}>
    {children}
  </div>
)

export const ListItem = ({selected, children, onClick}) => (
  <div className={cx(styles.ListItem, {[styles.Selected]: selected})} onClick={onClick}>
    <div className={cx(styles.Checkbox, selected && styles.checked)} />
    {children}
  </div>
)
